import React from 'react';
import Toast from 'components/Toast';
import PropTypes from 'prop-types';
import SupportButton from 'components/SupportButton';

const ToastHandler = ({
  toastType,
  showToast,
  onCloseHandler,
  title,
  description,
  duration = 5000
}) => {
  return (
    <Toast
      type={toastType}
      isBold
      open={showToast}
      title={title}
      onClose={onCloseHandler}
      timeout={duration}
    >
      {toastType === 'warning' && !!description && <div>{description}</div>}
      {toastType === 'error' && (
        <>
          {!!description && <div>{description}</div>}
          <SupportButton />
        </>
      )}
    </Toast>
  );
};

ToastHandler.defaultProps = {
  toastType: null,
  showToast: false,
  onCloseHandler: () => {},
  title: '',
  description: '',
  duration: 5000
};

ToastHandler.propTypes = {
  toastType: PropTypes.string,
  showToast: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  duration: PropTypes.number
};

export default ToastHandler;
